import {API_URL, THEME_COLOR, numberWithCommas, getDate} from "../constant"
import React, {useEffect, useState} from 'react';
import HeaderBack from "../layout/HeaderBack";
import "./HistoryTransaction.css";
import { useLocalStorage } from "../useLocalStorage";
import toast, { Toaster } from 'react-hot-toast';

import banner1 from "../logo.svg"

import { Link } from "react-router-dom";
import {CopyToClipboard} from 'react-copy-to-clipboard';


import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Card, CardMedia, CardContent, Divider, Avatar } from "@mui/material";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { deepOrange, deepPurple } from '@mui/material/colors';



const HistoryTransaction = ()=>{
    
    const [token, setToken] = useLocalStorage("token", "");
    const [transactions, setTransactions] = useState([]);
    const [transactionROs, setTransactionROs] = useState([]);
    const [recruits, setRecruits] = useState([]);
    const [value, setValue] = React.useState('1');


    function getTransaction(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/transaction`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    function getTransactionRO(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/transaction/ro`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    function getRecruit(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/transaction/recruit`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
      };

    useEffect(async ()=>{
        let response = await getTransaction();
        response = JSON.parse(response);
        if(response.status == 200){
            setTransactions(response.data)
        }else{
            toast.error(response.message)
        }

        response = await getTransactionRO();
        response = JSON.parse(response);
        if(response.status == 200){
            setTransactionROs(response.data)
        }else{
            toast.error(response.message)
        }

        response = await getRecruit();
        response = JSON.parse(response);
        if(response.status == 200){
            setRecruits(response.data)
        }else{
            toast.error(response.message)
        }
    },[])

    const TransactionHistory = (<div className="history-container">

            {
                transactions.map((value, index)=>{
                    return(
                        <div className="history-card">
                            <div className="history-flex-container">
                                <div className="history-image-container" style={{display:"none"}}>
                                    <img src={banner1} />
                                </div>
                                <div className="history-card-detail">
                                    <div className="history-item-name">{value.Code}</div>
                                    <div style={{fontSize: "10pt"}}>VA : {value.VirtualAccountNo}
                                        <CopyToClipboard text={value.VirtualAccountNo}
                                            onCopy={() => toast.success("copied to clipboard")}>
                                                <span style={{"cursor":"pointer"}} >
                                                    <i className="tiny material-icons prefix">content_copy</i>
                                                </span>
                                        </CopyToClipboard>
                                    </div>
                                    <div style={{fontSize: "10pt"}}>Status : {
                                        (value.Status == 1)?(
                                            <span className="history-status green accent-3">Success</span>
                                        ):(
                                            <span className="history-status yellow accent-3">Pending</span>
                                        )
                                    }</div>
                                    <div style={{fontSize: "8pt",color:"gray"}}>{getDate(new Date(value.SysDate))}</div>
                                </div>
                            </div>
                            <div className="history-flex-container">
                                <div className="history-card-price">
                                    <div className="history-grandtotal">Grand Total</div>
                                    <div className="history-amount">Rp {numberWithCommas(value.GrandTotal)}</div>
                                </div>
                                <div className="history-card-button">
                                    <Link to={`/detailhistory/${value.ID}`}>
                                        <button className="btn">Detail</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )


    const TransactionROHistory = (<div className="history-container">

            {
                transactionROs.map((value, index)=>{
                    return(
                        <div className="history-card">
                            <div className="history-flex-container">
                                <div className="history-image-container" style={{display:"none"}}>
                                    <img src={banner1} />
                                </div>
                                <div className="history-card-detail">
                                    <div className="history-item-name">{value.MemberName}</div>
                                    <div className="history-item-name">{value.Code}</div>
                                    <div style={{fontSize: "10pt"}}>VA : {value.VirtualAccountNo}
                                        <CopyToClipboard text={value.VirtualAccountNo}
                                            onCopy={() => toast.success("copied to clipboard")}>
                                                <span style={{"cursor":"pointer"}} >
                                                    <i className="tiny material-icons prefix">content_copy</i>
                                                </span>
                                        </CopyToClipboard>
                                    </div>
                                    <div style={{fontSize: "10pt"}}>Status : {
                                        (value.Status == 1)?(
                                            <span className="history-status green accent-3">Success</span>
                                        ):(
                                            <span className="history-status yellow accent-3">Pending</span>
                                        )
                                    }</div>
                                    <div style={{fontSize: "8pt",color:"gray"}}>{getDate(new Date(value.SysDate))}</div>
                                </div>
                            </div>
                            <div className="history-flex-container">
                                <div className="history-card-price">
                                    <div className="history-grandtotal">Grand Total</div>
                                    <div className="history-amount">Rp {numberWithCommas(value.GrandTotal)}</div>
                                </div>
                                <div className="history-card-button">
                                    <Link to={`/detailhistory/${value.ID}`}>
                                        <button className="btn">Detail</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )

    const RecruitList = (
        <div className="history-container">
            {
                recruits.map((value, index)=>{
                    let birthdate = new Date(value.BirthDate);
                    let joindate = new Date(value.JoinDate);
                    let fname = (value.FirstName).slice(0,1);
                    let lname = (value.LastName).slice(0,1);
                    return (
                        <Card sx={{padding:"10px", marginTop:"10px"}}>
                            <Stack direction="row" spacing={1} sx={{alignItems:"center", alignContent:"center"}}>
                                <Avatar sx={{ bgcolor: deepOrange[500] }}>{fname+lname}</Avatar>
                                <CardContent sx={{width:"100%"}}>
                                    <Typography variant="h6" component="div">{`${value.FirstName} ${value.LastName}`}</Typography>
                                    <Typography>{`${value.Code}`}</Typography>
                                    <div><small>Birth Date: {`${getDate(birthdate)}`}</small></div>
                                    <div><small>Join Date: {`${getDate(joindate)}`}</small></div>
                                    {
                                        (value.ID) ? (
                                            <div className="history-flex-container">
                                                <div className="history-card-price">
                                                    {/* <div className="history-grandtotal">Grand Total</div>
                                                    <div className="history-amount">Rp {numberWithCommas(value.GrandTotal)}</div> */}
                                                </div>
                                                <div className="history-card-button">
                                                    <Link to={`/detailhistory/${value.ID}`}>
                                                        <button className="btn">Detail</button>
                                                    </Link>
                                                </div>
                                            </div>
                                        ):(
                                            <></>
                                        )
                                    }
                                </CardContent>
                            </Stack>
                        </Card>
                    );
                })
            }
        </div>
    );


    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="History" />
            <Box sx={{ width: '100%', typography: 'body1', backgroundColor:"white" }}>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="lab API tabs example">
                    <Tab label="Personal Order" value="1" />
                    <Tab label="Downline Order" value="2" />
                    <Tab label="Recruit" value="3" />
                </TabList>
                </Box>
                <TabPanel value="1">{TransactionHistory}</TabPanel>
                <TabPanel value="2">{TransactionROHistory}</TabPanel>
                <TabPanel value="3">{RecruitList}</TabPanel>
            </TabContext>
            </Box>
        </React.StrictMode>
    );

}


export default HistoryTransaction;
